// extracted by mini-css-extract-plugin
module.exports = {"optional":"style__optional__wSOxt","label":"style__label__NxX12"};